import VueI18n from 'vue-i18n';

import pt from './locales/pt';

let instance;

export default {
  getInstance() {
    if (!instance) {
      throw new Error('Not initialized');
    }

    return instance;
  },
  initialize() {
    instance = new VueI18n({
      locale: 'pt',
      sync: false,
      messages: {
        pt,
      },
    });

    return instance;
  },
};
